var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionDialog',{attrs:{"persistent":"","max-width":400,"value":_vm.value,"bubble-icon":{
    icon: _vm.Icon.TrashCan,
    colour: _vm.iconColour,
  },"header":_vm.headerLabel || _vm.$tc('heading.genericDeleteEntity', 1, { entity: _vm.entity }),"primary-button":{
    label:
      _vm.primaryButtonLabel || _vm.$tc('button.genericDeleteEntity', 1, { entity: _vm.entity }),
    action: () => _vm.confirm(),
    colour: 'red',
    loading: _vm.loading,
    disabled: _vm.disabled,
  },"secondary-action":{
    label: _vm.$t('button.cancel'),
    action: () => _vm.cancel(),
    colour: 'transparent',
  }},scopedSlots:_vm._u([{key:"body",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }